import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

/**
 * Home Icon representing activities or main page at the bottom navigation
 */
export const HomeIcon: FunctionComponent<HomeIconProps> = ({
  size = 24,
  fillColor,
  isFilled = false,
  testID = 'HomeIcon',
}) => {
  const { colors } = useTheme()

  return (
    <Svg testID={tID(testID)} width={size} height={size} viewBox='0 0 24 20' fill='none'>
      {isFilled ? (
        <>
          <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.469 2.914a.75.75 0 00-.938 0l-10 8a.75.75 0 00.938 1.172l.781-.626v9.04c0 .414.336.75.75.75h16a.75.75 0 00.75-.75v-9.04l.782.626a.75.75 0 00.936-1.172l-10-8z'
            fill={fillColor || colors.iconActive}
          />
          <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.5 20c-.386 0-.75.114-.75.5v-.75h2.5v.75c0-.386-.364-.5-.75-.5h-1zm-2.25-5c0-1.214 1.036-2.25 2.25-2.25h1c1.214 0 2.25 1.036 2.25 2.25v5.5a.75.75 0 01-.75.75h-4a.75.75 0 01-.75-.75V15z'
            fill='#fff'
          />
          <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20 9.35a.75.75 0 01.75.75v10.4a.75.75 0 01-.75.75H4a.75.75 0 01-.75-.75V10.2a.75.75 0 011.5 0v9.55h14.5V10.1a.75.75 0 01.75-.75z'
            fill={fillColor || colors.iconActive}
          />
        </>
      ) : (
        <Path
          d={
            'M22.47 10.908l-10-8a.78.78 0 00-.94 0l-10 8a.755.755 0 00.94 1.18l.78-.63v9a.76.76 0 00.75.75h16a.76.76 0 00.75-.75v-9l.78.63a.74.74 0 00.47.16.75.75 0 00.47-1.34zm-3.22 8.84h-4.5v-4.75a2.25 2.25 0 00-2.25-2.25h-1a2.25 2.25 0 00-2.25 2.25v4.75h-4.5v-9.49l7.25-5.8 7.25 5.8v9.49z'
          }
          fill={fillColor || colors.iconActive}
        ></Path>
      )}
    </Svg>
  )
}

type HomeIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
  testID?: string
}
